import { reactive, toRefs } from "vue";
import type { Ref } from "vue";
import { os2 } from "@/utils/env";
import { useStorage } from "@vueuse/core";
import { TOKEN } from "@/pages/website/const";

export const gamerToken = useStorage(TOKEN, "")
const globalData = reactive<{
  gameId: string;
  videoUrl: string;
  isShowVideo: boolean;
  isShowSubscribePop: boolean;
  isShowSubscribeSuccessPop: boolean;
  isPc: boolean;
  config: IConfig;
  newsTabsList: INewsTab[];
  curNewsTab: number;
  isPlayBgm: boolean;
  subscribeCount: number;
  eventConfigData: IEventConfig;
  currentActivity: IFeature | null;
  isSubscribed: boolean;
  ssoToken: string;
  userInfo: IUserProfileData;
  isWapShowMediaPop: boolean;
  isInitVisit: boolean;
  isShowDownloadButton: boolean;
  isDownloadShowWxPop: boolean;
  currentMenuIndex:number;
}>({
  gameId:"",
  videoUrl:"",
  isShowVideo: false,
  isShowSubscribePop: false,
  isShowSubscribeSuccessPop: false,
  isPc: os2 === "pc",
  config: {
    pcBgUrl: "",
    mBgUrl: "",
    sn: "",
    created: 0,
    pc_slogan: "",
    m_slogan: "",
    pcVideoUrl: "",
    mTsVideoUrl: "",
    mVideoUrl: "",
    mVideoGif:"",
    topVideoUrl: "",
    pics: [],
    activityImg: "",
    activityUrl: "",
    socialMedia: {
      qq: "",
      douyin: "",
      weixin: "",
      downloadQr: "",
      weibo: "",
      xiaohongshu: "",
      weixinDesc: "",
      weixinxiaochengxu: "",
      weixinxiaochengxuDesc: "",
      bilibili: "",
      qqkj: "",
      downloadOpenDate: [0, 0]
    },
    music: "",
    logoPc: "",
    logoM: "",
    gameDesc:"",
    gameDescLine2:"",
    videoPoster: "",
    service: "",
    serviceDesc:"",
    milestone: {
      list:[]
    },
    record: {
      list:[]
    },
    recordNew: {
      list:[]
    },
    subscribePrize: {
      list:[]
    },
    gameView: {
      list: []
    },
    gameViewNew:{
      list: []
    },
    gameFeature:{
      list: []
    },
    gameVideo: {
      list: []
    },
    gameRole: {
      list: []
    },
    ageUrl: "",
    fszl:{
      list: []
    },
    iconM: "",
    videoButtonTop: "0",
    videoButtonLeft: "0",
    videoButtonBottomM: "0",
    videoButtonLeftM: "0",
    videoButtonBottomMSmall: "0",
    videoButtonLeftMSmall: "0",
  },
  newsTabsList: [],
  curNewsTab: 0,
  isPlayBgm: false,
  subscribeCount: 0,
  
  eventConfigData: {
    event_name: "",
    features: []
  },
  currentActivity: null,
  isSubscribed: false,
  ssoToken: "",
  userInfo: {
    user_id: "",
    mobile: ""
  },
  isWapShowMediaPop: false,
  isInitVisit: false,
  isShowDownloadButton: false,
  isDownloadShowWxPop: false,
  currentMenuIndex: 0
});

export const useGlobalData = function (): {
  gameId:Ref<string>;
  videoUrl:Ref<string>;
  isShowVideo:Ref<boolean>;
  isShowSubscribePop: Ref<boolean>;
  isShowSubscribeSuccessPop: Ref<boolean>;
  isPc: Ref<boolean>;
  config: Ref<IConfig>;
  newsTabsList: Ref<INewsTab[]>;
  curNewsTab: Ref<number>;
  isPlayBgm: Ref<boolean>;
  subscribeCount: Ref<number>;
  eventConfigData: Ref<IEventConfig>;
  currentActivity: Ref<IFeature | null>
  isSubscribed: Ref<boolean>;
  ssoToken: Ref<string>;
  userInfo: Ref<IUserProfileData>;
  isWapShowMediaPop: Ref<boolean>;
  isInitVisit: Ref<boolean>;
  isShowDownloadButton: Ref<boolean>;
  isDownloadShowWxPop: Ref<boolean>;
  currentMenuIndex: Ref<number>;
} {
  return toRefs(globalData);
};
